import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AppRoute } from '../../../routing/types/app-route';

@Component({
    selector: 'app-footer',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink],
    styles: `
        @use "variables" as *;


        :host {
            background-color: $white;
        }

        footer {
            display: flex;
            color: $dark-blue;
            font-size: 16px;
            padding: 1.9rem 0em;
            gap: 2rem;
            align-items: center;
            justify-content: space-between;
            border-top: 1px solid $dark-blue;

            @media screen and (max-width: 1250px) {
                gap: 1.5rem;
            }

            @media screen and (max-width: 1024px) {
                flex-direction: column;
                gap: 2.5rem;
                align-items: center;
            }
        }

        a {
            color: $dark-blue;
            text-decoration: none;
            transition: color 0.1s;
            font-weight: 600;
            text-transform: uppercase;
            font-size: 1rem;
            letter-spacing: 0.02em;

            &:hover {
                color: $red;
            }

            @media screen and (max-width: 430px) {
                font-size: 0.8rem;
            }
        }

        .left-section {
            display: flex;
            flex-direction: row;
            gap: 2.8rem;
            align-items: center;
            flex-shrink: 0;

            @media screen and (max-width: 1250px) {
                gap: 1.5rem;
            }

            @media screen and (max-width: 1024px) {
                width: 100%;
                justify-content: center;
                gap: 5vw;
                flex-wrap: wrap;
                padding: 0 10px;
            }

            @media screen and (max-width: 430px) {
                gap: 3vw;
                padding: 0 8px;
            }

            .vln-logo {
                img {
                    opacity: 1!important;
                    height: 50px;
                    width: auto;
                }

                @media screen and (max-width: 1024px) {
                    img {
                        height: 35px;
                    }
                }

                @media screen and (max-width: 430px) {
                    img {
                        height: 28px;
                    }
                }
            }

            .links {
                display: flex;
                flex-direction: column;
                gap: 0.5rem;

                @media screen and (max-width: 1024px) {
                    flex-direction: row;
                    gap: 1rem;
                    flex-wrap: wrap;
                }

                @media screen and (max-width: 430px) {
                    gap: 0.6rem;
                }
                
                a {
                    display: block;
                }
            }
        }

        .right-section {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-end;
            gap: 3rem;
            flex: 1;
            flex-wrap: nowrap;

            @media screen and (max-width: 1250px) {
                gap: 1.5rem;
            }

            @media screen and (max-width: 1024px) {
                width: 100%;
                justify-content: center;
                gap: 4vw;
                padding: 0 10px;
                flex-wrap: wrap;
            }

            @media screen and (max-width: 430px) {
                gap: 2vw;
                padding: 0 8px;
            }

            .partner-logo {
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    height: 60px;
                    width: auto;
                    max-width: 150px;
                    object-fit: contain;
                    opacity: 1;
                }

                @media screen and (max-width: 1024px) {
                    flex-shrink: 0;
                    
                    img {
                        height: 40px;
                        max-width: 100px;
                    }
                }
            }
        }

        .license-section {
            padding: 0 2rem 2rem 2rem;

            @media screen and (max-width: 1024px) {
                padding: 0 1rem 1rem 1rem;
            }
        }

        .license-text {
            background-color: $light-blue;
            padding: 1rem 1.5rem;
            text-align: center;
            color: $dark-blue;
            border-radius: 6px !important;

            //Desktop 
            font-size: 13px;
            line-height: 16px;
            
            @media screen and (max-width: 768px) {
                font-size: 10px;
                line-height: 14px;
            }
        }
    `,
    template: `
        <footer class="container">
            <div class="left-section">
                <div class="vln-logo">
                    <img src="/assets/logos/vln_tiny.svg" alt="VideoLectures.NET Logo"/>
                </div>
                <div class="links">
                    <a routerLink="{{AppRoutes.Company}}">Who We Are</a>
                    <a routerLink="/{{AppRoutes.PrivacyPolicy}}">Privacy</a>
                    <a routerLink="/{{AppRoutes.PrivacyTermsOfUse}}">Terms of Use</a>
                </div>
            </div>

            <div class="right-section">
                <div class="partner-logo">
                    <img src="/assets/images/partners/unesco.svg" alt="UNESCO"/>
                </div>
                <div class="partner-logo">
                    <img src="/assets/images/partners/joze_stef_ai.svg" alt="Jožef Stefan Institute AI"/>
                </div>
                <div class="partner-logo">
                    <img src="/assets/images/partners/unesco_only.svg" alt="UNESCO"/>
                </div>
                <div class="partner-logo">
                    <img src="/assets/logos/ijsV2.svg" alt="Jožef Stefan Institute"/>
                </div>
            </div>
        </footer>
        <div class="license-section">
            <div class="license-text container">
                Except where otherwise noted, content on this site is licensed under a Creative Commons Attribution-NonCommercial-NoDerivs 4.0 International license.
            </div>
        </div>
    `
})
export class FooterComponent {
    public AppRoutes = AppRoute;
}
